import http from 'core/services/http';
import Config from 'core/config';

class TcService {
  static getTC(tcId) {
    return http.get(`${Config.apiUrl}/testcenterdto/${tcId}`);
  }

  static getTcCycle(id) {
    return http.get(`${Config.apiUrl}/testcentercycle/${id}`);
  }

  static getTcCycleEvents(tcCycleId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/events`);
  }

  static getTcCycleFilteredEvents(tcCycleId) {
    return http.get(`${Config.apiUrl}/testcentercycle/${tcCycleId}/filteredevents`);
  }

  static getTCCycles(id, status) {
    return http.get(`${Config.apiUrl}/testcenter/${id}/testcentercycle/${status}`);
  }
}

export default TcService;
